// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reject-popup {
  padding: 20px;
  min-width: 448px;
}

.reject-popup-header {
  font-size: 20px;
  font-weight: 600;
  color: #54595e;
  margin-bottom: 10px;
}

.reject-popup-subheader {
  font-size: 14px;
  font-weight: 400;
  color: #54595e99;
  margin-bottom: 20px;
}

.reject-popup-actions {
  display: flex;
  gap: 26px;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}

.reject-popup-cancel {
  width: 100%;
  border-radius: 100px !important;
  height: 44px;
}
.select-placeholder {
  font-size: 14px;
  font-weight: 500;
  color: #acacac;
}
.reject-popup-reject {
  width: 100%;
  background-color: #f15e22;
  color: #ffffff;
  height: 44px;
  font-weight: 600px;
  font-size: 15px;
  border: none;
  border-radius: 40px;
  cursor: pointer;
}
.reject-error {
  position: absolute;
  left: 50px;
  bottom: 80px;
  font-size: 14px;
  font-weight: 400;
}
.other-reason-textarea {
  resize: none;
  width: 95%;
  height: 80px;
  border: 1px solid #e3e3e3;
  border-radius: 10px;
  padding: 10px;
}
.other-reason-error {
  position: absolute;
  bottom: 80px;
  left: 40px;
}
.reject-dropdown-icon {
  margin-right: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/components/rejectPopup/rejectPopup.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,+BAA+B;EAC/B,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB","sourcesContent":[".reject-popup {\n  padding: 20px;\n  min-width: 448px;\n}\n\n.reject-popup-header {\n  font-size: 20px;\n  font-weight: 600;\n  color: #54595e;\n  margin-bottom: 10px;\n}\n\n.reject-popup-subheader {\n  font-size: 14px;\n  font-weight: 400;\n  color: #54595e99;\n  margin-bottom: 20px;\n}\n\n.reject-popup-actions {\n  display: flex;\n  gap: 26px;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.reject-popup-cancel {\n  width: 100%;\n  border-radius: 100px !important;\n  height: 44px;\n}\n.select-placeholder {\n  font-size: 14px;\n  font-weight: 500;\n  color: #acacac;\n}\n.reject-popup-reject {\n  width: 100%;\n  background-color: #f15e22;\n  color: #ffffff;\n  height: 44px;\n  font-weight: 600px;\n  font-size: 15px;\n  border: none;\n  border-radius: 40px;\n  cursor: pointer;\n}\n.reject-error {\n  position: absolute;\n  left: 50px;\n  bottom: 80px;\n  font-size: 14px;\n  font-weight: 400;\n}\n.other-reason-textarea {\n  resize: none;\n  width: 95%;\n  height: 80px;\n  border: 1px solid #e3e3e3;\n  border-radius: 10px;\n  padding: 10px;\n}\n.other-reason-error {\n  position: absolute;\n  bottom: 80px;\n  left: 40px;\n}\n.reject-dropdown-icon {\n  margin-right: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
